import { ProfileDetailsType } from "./ProfileDetailsType"

export type FiscalDetailsType = Pick<ProfileDetailsType, 
"fiscalYearEndDate" |
"partialIncomeMonth" |
"ownerOccupiedFlag">

export const initialFiscalDetails: FiscalDetailsType = {
  fiscalYearEndDate: null,
  ownerOccupiedFlag: null,
  partialIncomeMonth: null,
}

export const keysOfFiscalDetailsType: (keyof FiscalDetailsType)[] = [
  "fiscalYearEndDate",
  "partialIncomeMonth",
  "ownerOccupiedFlag"
];